import React, { type ReactNode, type ReactElement } from 'react';

import { theme as defaultTheme } from '@lucid/theme';
import { useSiteMetadata } from '@lucid/hooks';
import { render, type RenderOptions } from '@testing-library/react';

import { ThemeProvider } from '../theme-provider/theme-provider';
import type { Lucid } from '../../types/types';

export interface ThemeHelperProps extends Partial<Lucid.Theme.Utility.Props> {
  /** The rendered children with the correct theme. */
  children: ReactNode;
  /** The available sites to set proper theme values. */
  product?: Lucid.Site.Product;
}

export const ThemeHelper = ({ children, theme = defaultTheme, product }: ThemeHelperProps): ReactElement => {
  const { product: siteProduct } = useSiteMetadata();
  const currentSiteProduct = product || siteProduct || process.env.PRODUCT || 'chart';

  return (
    <ThemeProvider
      key={`@lucid/components-react-theme-helper-${currentSiteProduct}`}
      product={currentSiteProduct}
      theme={theme}
    >
      {children}
    </ThemeProvider>
  );
};

const themeHelperRender = (ui: ReactElement, options?: RenderOptions) =>
  render(ui, {
    wrapper: ThemeHelper,
    ...options,
  });

const themeHelper = {
  render: themeHelperRender,
};

export { themeHelper };

export default ThemeHelper;
